import { UnknownObject } from "@core/store/types/common";

export const prepareExcludedFilters = (excludedFilters: UnknownObject): UnknownObject => {
  return Object.keys(excludedFilters).reduce((acc, key) => {
    const newKey = key.replace(/^excluded/, "").replace(/^./, c => c.toLowerCase());
    // @ts-ignore
    acc[newKey] = excludedFilters[key];
    return acc;
  }, {});
};